import { render, staticRenderFns } from "./TrackAndTrace.vue?vue&type=template&id=c4ed4f24&scoped=true&"
import script from "./TrackAndTrace.vue?vue&type=script&lang=js&"
export * from "./TrackAndTrace.vue?vue&type=script&lang=js&"
import style0 from "./TrackAndTrace.vue?vue&type=style&index=0&id=c4ed4f24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ed4f24",
  null
  
)

export default component.exports